import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router';

import * as graphql from '@treams/treams-network';
import { Jumbo } from '@treams/treams-ui';

import FeedbackRequestModals from '../packages/kakapo-ui-application/pages/feedback-v2/requests/FeedbackRequestModals';
import IncomingFeedbackList from './IncomingFeedbackList';
import UserFeedbackButtons from './UserFeedbackButtons';
import UserFeedbackTabs from './UserFeedbackTabs';

export default function UserFeedback() {
	const { t } = useTranslation();

	const { params } = useRouteMatch<{ id: string }>();
	const userID = params.id;

	const userQuery = graphql.useUserQuery({ variables: { id: userID } });

	const query = graphql.useFeedbackRequestsQuery({
		variables: { userID, last: 10, isArchived: false },
	});
	const [fetchArchived, archivedQuery] = graphql.useFeedbackRequestsLazyQuery({
		variables: { userID, last: 10, isArchived: true },
	});
	return (
		<>
			<Jumbo
				title={t('user.feedback.index.title', {
					name: userQuery.data?.user.firstName,
				})}
				button={<UserFeedbackButtons user={userQuery.data?.user as graphql.User} />}
				footer={<UserFeedbackTabs user={userQuery.data?.user as graphql.User} />}
			/>

			<IncomingFeedbackList
				query={query}
				archivedQuery={archivedQuery}
				fetchArchived={fetchArchived}
				userID={userID}
			/>

			<FeedbackRequestModals userID={userID} refetch={query.refetch} />
		</>
	);
}
